// import React, { useState } from 'react';
// import { Button, Input, Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/react";
// import { getAllSalesRep } from "../../store/slices/customerSlice";
// import { useDispatch } from 'react-redux';
// import axios from 'axios';

// const AddAssignee = ({addAssignee, closeAssignee}) => {
//   const dispatch = useDispatch();
//     const [name, setName] = useState('');

//     const addAssingee = async () => {
//       let data = {
//         SalesRepName: name
//       }
//       try {
//         let token = localStorage.getItem("accessToken");
//         let header = {
//           headers: {
//           authorization: `Bearer ${token}`,
//           },
//         };
//         let res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/suppliersalesreps/create`, data, header);
//         dispatch(getAllSalesRep());
//         closeAssignee();
//       } catch (error) {
//         const err = error.response.data.message;
//         // console.log(err);
//       }
//     }

//   return (
//     <Modal
//         size={"xs"}
//         isOpen={addAssignee}
//         onClose={closeAssignee}
//         placement="center"
//       >
//         <ModalContent>
//           {(onClose) => (
//             <>

//               <ModalBody>
//               <Input
//                 type="text"
//                 className="my-2"
//                 label="Add Sales Reprensentative"
//                 labelPlacement={"outside"}
//                 placeholder="Enter name"
//                 description={''}
//                 onChange={(event)=>setName(event.target.value)}
//               />
//               <div className="grid grid-cols-2 gap-2 pb-3">
//                 <Button className="border-2 border-orange-500 text-orange-500 bg-transparent hover:bg-orange-500 hover:text-white hover:border-none" onClick={()=>closeAssignee()}>Cancel</Button>
//                 <Button className="border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500 hover:text-white hover:border-none" onClick={()=>addAssingee()}>Submit</Button>
//               </div>
//               </ModalBody>
//             </>
//           )}
//         </ModalContent>
//       </Modal>
//   )
// }

// export default AddAssignee
import React, { useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalContent,
  ModalBody,
} from "@nextui-org/react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";

import { getAllSalesRep } from "../../store/slices/customerSlice";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const AddAssignee = ({ addAssignee, closeAssignee }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  // 🔐 Latest auth header
  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": "application/json",
    },
  });

  // 🔁 Ensure fresh token
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  const addAssigneeFn = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error("Please enter a name");
      return;
    }

    setSaving(true);
    const data = { SalesRepName: trimmed };
    const url = `${process.env.REACT_APP_SERVER_URL}/suppliersalesreps/create`;

    try {
      const headers = await ensureAuth();
      await axios.post(url, data, headers);

      toast.success("Sales rep added ✅");
      dispatch(getAllSalesRep());
      closeAssignee?.();
    } catch (error) {
      // one-time retry on 401
      if (error?.response?.status === 401) {
        try {
          const headers = await ensureAuth();
          await axios.post(url, data, headers);

          toast.success("Sales rep added ✅");
          dispatch(getAllSalesRep());
          closeAssignee?.();
          return;
        } catch {}
      }
      const msg = error?.response?.data?.message || "Failed to add sales rep";
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      size="xs"
      isOpen={addAssignee}
      onClose={closeAssignee}
      placement="center"
    >
      <ModalContent>
        {() => (
          <ModalBody>
            <div>Add Sales Representative</div>
            <Input
              type="text"
              className="my-2"
              // label="Add Sales Representative"
              labelPlacement="outside"
              placeholder="Enter name"
              onChange={(e) => setName(e.target.value)}
              value={name}
              isDisabled={saving}
            />
            <div className="grid grid-cols-2 gap-2 pb-3">
              <Button
                variant="flat"
                color="warning"
                onPress={closeAssignee}
                isDisabled={saving}
              >
                Cancel
              </Button>
              <Button
                variant="flat"
                color="success"
                onPress={addAssigneeFn}
                isDisabled={!name.trim() || saving}
                isLoading={saving}
              >
                Submit
              </Button>
            </div>
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  );
};

export default AddAssignee;
